module.exports = __webpack_public_path__ + "img/mp_code.jpg";